import { BACKEND_URL } from "../env";
import { ApiError } from "../types/api-error";
import { App } from "../types/entities";

export async function activateApp(
  appId: string
): Promise<{ success: boolean; app?: App; error?: ApiError }> {
  try {
    const response = await fetch(
      `${BACKEND_URL}/apps/${encodeURIComponent(appId)}/activate`,
      { method: "POST", credentials: "include" }
    );
    if (response.status >= 400) {
      const errorData = await response.json().catch(() => ({}));
      const code =
        errorData?.code ??
        (response.status === 409
          ? "conflict"
          : response.status === 404
            ? "not_found"
            : undefined);
      const message = errorData?.message || "Failed to activate tool.";
      return {
        success: false,
        error: { status: response.status, code, message },
      };
    }
    const app = (await response.json()) as App;
    return { success: true, app };
  } catch {
    return {
      success: false,
      error: { message: "Network error. Please try again." },
    };
  }
}
